import React from 'react';
import classNames from "classnames";
import intl from "react-intl-universal";
import {useAppState} from "@stores/AppStateContext";

import {ClientUser, WorkspaceUser} from "../../../API";

import {DeleteIcon} from "../../components/icons/DeleteIcon";
import {Tooltip} from "../../components/Tooltip"

import {MODALS} from "../modals/modal-names";

export interface WsUserCardProps {
    user: ClientUser;
    wsUser: WorkspaceUser;
    className?: string;
}

export const WsUserActions = ({user, wsUser, className}: WsUserCardProps) => {
    const appState = useAppState();
    return (
        <div
            className={classNames({
                [className!]: className,
            })}
        >
            <Tooltip title={intl.get('common.remove').d('Remove')}>
                <DeleteIcon
                    size={20}
                    className={'Members-icon'}
                    onClick={() => appState.setModal({name: MODALS.REMOVE_USER_FROM_WORKSPACE, params: {
                        user, wsUser
                    }})}
                />
            </Tooltip>
        </div>
    )
}
